//import Vue from "vue"

import store from "@/store/store";
import { apiFetch } from "@/utils";

function getFrsList(year = null, displayLoader = true) {
  return apiFetch("fournisseur" + (year !== null ? ("?year=" + year) : ""), false, displayLoader);
}

function getFrsListAdminAll(year = null) {
  return apiFetch("fournisseur/all" + (year != null ? ("?year=" + year) : ""));
}

function getFrsOnCampaignGuidList(year) {
  return apiFetch("fournisseur/campaign-frs-guids?year=" + year);
}

function getFrsInfosByYear(year, frsGuid) {
  return apiFetch("fournisseur/infos?year=" + year + "&frsGuid=" + frsGuid);
}

function getFrsLastContactUpdateDate(frsGuid) {
  return apiFetch("fournisseur/lastmodifcontact?frsGuid=" + frsGuid);
}

function getFrsIntranetRubriques(frsGuid) {
  return apiFetch("fournisseur/intranetrubriques?frsGuid=" + frsGuid);
}

function getFrsIntranetDocumentLastDate(frsGuid, codeRubrique, count) {
  return apiFetch("fournisseur/documentlastdate?frsGuid=" + frsGuid + "&codeRubrique=" + codeRubrique + "&count=" + count);
}

function getFrsVersementsByYear(frsGuid, year) {
  return apiFetch("fournisseur/versements?frsGuid=" + frsGuid + "&year=" + year)
}

function getFrsAppointmentFormData(frsGuid, year, realAppointmentFormCa = false) {
  return apiFetch("fournisseur/appointment-form-data?frsGuid=" + frsGuid + "&year=" + year + "&realAppointmentFormCA=" + realAppointmentFormCa);
}

function getTopFrsList(pdvGuid) {
  return apiFetch("fournisseur/top?pdvGuid=" + pdvGuid);
}

function getTopFrsPreviResults(adhGuid) {
  return apiFetch("fournisseur/previ/results?tierSdcGuid=" + adhGuid);
}

function updatePreviPdvFrs(pdvGuid, frsGuid, progress, del = false) {
  return apiFetch("fournisseur/previ/update?pdvGuid=" + pdvGuid + "&toUpdateFrsGuid=" + frsGuid + "&progress=" + (progress || 0) + "&delete=" + del);
}

function getFrsPreviResults(frsGuid) {
  return apiFetch("fournisseur/previ/results-by-frs?resultFrsGuid=" + frsGuid);
}

function getFrsSimulableInfos(frsGuid) {
  return apiFetch("fournisseur/simulable-status");
}

function toggleFrsCampaign(frsGuid, year) {
  return apiFetch("fournisseur/toggle-campaign-frs?frsGuid=" + frsGuid + "&year=" + year);
}

function getNomenclatureByLevel(level) {
  return new Promise((resolve) => {
    apiFetch("fournisseur/nomenclature?level=" + level).then(res => {
      res.sort((a, b) => a.Libelle < b.Libelle ? -1 : 1);
      resolve(res);
    })
  });
}

function getFrsRfaState(periodId, concept = 1, globalView = false, displayLoader = true) {
  return apiFetch(`fournisseur/rfa-state?periodId=${periodId}&concept=${concept}&globalView=${globalView}`, false, displayLoader);
}

function getFrsContractState(year, globalView = false,displayLoader = true) {
  return apiFetch("fournisseur/contract-state?year=" + year + "&globalView=" + globalView, false, displayLoader);
}

function getFrsRubriques(frsGuid) {
  return apiFetch("fournisseur/rubriques?frsGuid=" + frsGuid, false, false);
}

function getFrsRubriqueDocuments(tiersId, rubriqueId) {
  return apiFetch("fournisseur/rubrique-documents?tiersId=" + tiersId + "&rubriqueId=" + rubriqueId, false, false);
}

// CaRfaDataController.GetCaRfaBySuppliers
function getCaRfaBySuppliers(/*List<string*/ guidsFrs, /*List<int*/ idsPeriode, annexeType, paymentStatus) {
  var _guidsFrs = JSON.stringify(guidsFrs);
  var _idsPeriode = JSON.stringify(idsPeriode);

  // ES6 syntaxe
  return apiFetch(`datas/fournisseurs?guidsFrs=${_guidsFrs}&idsPeriode=${_idsPeriode}&annexeType=${annexeType}&paymentStatus=${paymentStatus}`);
}


// ContractController.GetContractDatas
function getContractDatas(/*List<string*/ guidsFrs, /*List<int*/ idsCampaign) {
  var _guidsFrs = JSON.stringify(guidsFrs);
  var _idsCampaign = JSON.stringify(idsCampaign);

  // ES6 syntaxe
  return apiFetch(`contract/datas?guidsFrs=${_guidsFrs}&idsCampaign=${_idsCampaign}`);
}

// ContractController.GetContractPaymentType
function getContractPaymentType(year) {
  // ES6 syntax
  return apiFetch(`contract/payment?year=${year}`)
}

function getNewsletterDatas(frsGuid) {
  return apiFetch(`newsletter-frs/datas?frsGuid=${frsGuid}`)
}

export default {
  getFrsList,
  getFrsListAdminAll,
  getFrsInfosByYear,
  getFrsOnCampaignGuidList,
  getFrsLastContactUpdateDate,
  getFrsIntranetRubriques,
  getFrsIntranetDocumentLastDate,
  getFrsVersementsByYear,
  getFrsAppointmentFormData,
  getTopFrsList,
  updatePreviPdvFrs,
  getTopFrsPreviResults,
  getFrsPreviResults,
  toggleFrsCampaign,
  getNomenclatureByLevel,
  getFrsSimulableInfos,
  getFrsRfaState,
  getFrsContractState,
  getFrsRubriques,
  getFrsRubriqueDocuments,
  getCaRfaBySuppliers,
  getContractDatas,
  getContractPaymentType
}

export {
  getFrsList,
  getFrsListAdminAll,
  getFrsInfosByYear,
  getFrsOnCampaignGuidList,
  getFrsLastContactUpdateDate,
  getFrsIntranetRubriques,
  getFrsIntranetDocumentLastDate,
  getFrsVersementsByYear,
  getFrsAppointmentFormData,
  getTopFrsList,
  updatePreviPdvFrs,
  getTopFrsPreviResults,
  getFrsPreviResults,
  toggleFrsCampaign,
  getNomenclatureByLevel,
  getFrsSimulableInfos,
  getFrsRfaState,
  getFrsContractState,
  getFrsRubriques,
  getFrsRubriqueDocuments,
  getCaRfaBySuppliers,
  getContractDatas,
  getContractPaymentType,
  getNewsletterDatas
}




// WEBPACK FOOTER //
// ./src/utils/frs.js